import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from '@schemas'
import type { UserStateType } from '@redux/types'

// initial state
const initialState: UserStateType = {
	user: new User(),
	language: '',
}

const slice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		USER: (state: UserStateType, action: PayloadAction<UserStateType['user']>) => {
			state.user = action.payload
		},

		LANGUAGE: (state: UserStateType, action: PayloadAction<string>) => {
			state.language = action.payload
		},
	},
})

export const userActions = slice.actions
export default slice.reducer
